<div class="dialog-container">
    <div mat-dialog-content class="dialog-content">
        <h3 *ngIf="data.title">{{data.title}}</h3>
        <h4>{{data.message}}</h4>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <ng-container *ngFor="let action of data.actions">
            <div *ngIf="action.color then flat_button; else stroked_button;"></div>
            <ng-template #flat_button>
                <button mat-flat-button [mat-dialog-close]="action.result" [style.background]="action.color" >
                    {{action.text}}
                </button>
            </ng-template>
            <ng-template #stroked_button>
                <button mat-stroked-button class="default-custom-button" [mat-dialog-close]="action.result">
                    {{action.text}}
                </button>
            </ng-template>
        </ng-container>
    </div>
</div>